import { render, staticRenderFns } from "./copyWorkList.vue?vue&type=template&id=37abf11b&scoped=true"
import script from "./copyWorkList.vue?vue&type=script&lang=js"
export * from "./copyWorkList.vue?vue&type=script&lang=js"
import style0 from "./copyWorkList.vue?vue&type=style&index=0&id=37abf11b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37abf11b",
  null
  
)

export default component.exports